import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const getCampaigns = async (filter) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Campaign/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const saveCampaign = async (campaign) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Campaign/save`, campaign, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCampaign = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/Campaign/delete/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
